import * as React from 'react';
export const perplexitySvg = React.forwardRef(function perplexitySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#407E8C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'm8.721 4 6.617 6.096V4.014h1.287v6.11L23.271 4v6.95H26v10.026h-2.72v6.189l-6.655-5.847v5.914h-1.287v-5.817l-6.61 5.82v-6.26H6V10.95h2.721V4Zm5.646 8.223h-7.08v7.48h1.44v-2.36l5.64-5.12Zm-4.35 5.685v6.489l5.32-4.687v-6.635l-5.32 4.833Zm6.646 1.74V13.07l5.322 4.833v3.074h.007v3.354l-5.33-4.682Zm6.617.055h1.432v-7.48h-7.026l5.594 5.068v2.412Zm-1.296-8.753V6.927l-4.368 4.024h4.367Zm-7.607 0h-4.368V6.927l4.368 4.024Z',
      clipRule: 'evenodd',
    }),
  );
});
perplexitySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var perplexity = {
  category: 'brand',
  colorable: false,
  name: 'perplexity',
  svg: perplexitySvg,
};
